<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button *ngIf="(view === 'weighting' && weightContainers?.length)
      || view === 'summary'
      || (view === 'manual' && weightContainers?.length)
      || (view === 'manual' && scaleActivated)"
                  mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="back()"
                  color="orange"
                  fill="solid">
        <ion-icon name="arrow-back-outline"></ion-icon>
        {{ 'common.back' | transloco }}
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'weightedItem.weighAnItem' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar mode="md"
               color="orange"
               *ngIf="view !== 'setup'"
               class="subheader">
    <ion-title>{{ selectedItem ? ('weightedItem.weighingWithContainer' | transloco: { containerName: selectedItem.name }) : ('weightedItem.weighingWithoutContainer' | transloco) }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="weight-modal">
    <div *ngIf="view === 'setup'"
         class="weight-modal__setup">
      <p>{{ 'weightedItem.tareInstructions' | transloco }}</p>
      <div class="weight-modal__setup__containers">
        <ion-card *ngFor="let item of weightContainers"
                  color="whitesmoke"
                  class="weight-modal__setup__container"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSelectContainer(item)">
          <ion-card-header>
            <ion-card-title>{{item.name}}</ion-card-title>
          </ion-card-header>
        </ion-card>
      </div>
    </div>

    <div *ngIf="view === 'weighting'"
         class="weight-modal__weighting">
      <div>
        {{scaleWeight}} {{scaleWeightUnitType}}
      </div>
    </div>
    <div *ngIf="view === 'manual'"
         class="weight-modal__manual">
      <ion-row>
        <ion-col>
          <div>
            {{scaleWeight}} {{scaleWeightUnitType}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="unit-type-radio-button">
          <ion-radio-group [value]="scaleWeightUnitType"
                           (ionChange)="onScaleWeightUnitTypeChange($event)">
            <ion-item lines="none">
              <ion-label><b>{{ 'weightedItem.unitType' | transloco }}</b></ion-label>
            </ion-item>

            <ion-item lines="none" *ngFor="let item of SCALE_WEIGHT_UNIT_OPTIONS | keyvalue">
              <ion-radio [value]="item.value.value"></ion-radio>
              <ion-label>
                {{item.value.name}}
              </ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-col>
      </ion-row>

      <pos-numeric-keyboard [value]="scaleWeight"
                            (onValueChange)="scaleWeight = +$event"
                            (submitEvent)="onLockWeight()"
                            [useForWeighingOutput]="true"
                            [buttons]="[]">
      </pos-numeric-keyboard>
    </div>
    <div *ngIf="view === 'summary'">
      <ion-list class="weight-modal__summary">
        <ion-item color="whitesmoke">
          <ion-label>{{menuItem.name}}</ion-label>
          <ion-label slot="end">{{menuItem.scale.weight}} {{menuItem.scale.weight_unit}}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'weightedItem.price' | transloco }} </ion-label>
          <ion-label slot="end">{{ menuItem.price | currency }}/{{menuItemWeightUnitType}} </ion-label>
        </ion-item>
        <ion-item *ngIf="selectedItem">
          <ion-label>{{ 'weightedItem.container' | transloco }} {{selectedItem.name}}</ion-label>
          <ion-label slot="end">-{{selectedItem.weight}} {{selectedItem.unit}}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'weightedItem.totalWeight' | transloco }}</ion-label>
          <ion-label slot="end">{{menuItem.scale.weight_without_container}} {{menuItem.scale.weight_unit}}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'weightedItem.totalPrice' | transloco }}</ion-label>
          <ion-label slot="end">{{menuItem.scale.item_price_by_weight | currency}}</ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="start">
      <ion-button mode="md"
                  *ngIf="view === 'setup'"
                  color="danger"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSkipContainer()">{{ 'weightedItem.continueWithoutContainer' | transloco }}</ion-button>
      <ion-button mode="md"
                  *ngIf="view === 'weighting'"
                  color="danger"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onManualWeight()">{{ 'weightedItem.manualWeighing' | transloco }}</ion-button>
      <ion-button mode="md"
                  *ngIf="view === 'summary'"
                  color="danger"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onStartOver()">{{ 'weightedItem.startOver' | transloco }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  *ngIf="view === 'weighting' || view === 'manual'"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onLockWeight()">{{ 'weightedItem.lockWeight' | transloco }}</ion-button>
      <ion-button mode="md"
                  *ngIf="view === 'summary'"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onAddToOrder()">{{ 'weightedItem.addToOrder' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>